




















































import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
} from "@nuxtjs/composition-api";
import { SfButton, SfIcon, SfSidebar } from "@storefront-ui/vue";
import { useUiHelpers } from "~/composables";
import { CategoryTree } from "~/modules/GraphQL/types";
import MenuOption from "./MenuOption.vue";

interface CustomLink {
  link: string;
  name: string;
}

export default defineComponent({
  name: "MenuDrawer",
  components: {
    SfSidebar,
    SfButton,
    SfIcon,
    MenuOption,
  },
  props: {
    customLinks: {
      type: Array as PropType<CustomLink[]>,
      default: () => [],
    },
    categoryTree: {
      type: Array as PropType<CategoryTree[]>,
      default: () => [],
    },
    isDrawerOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup(_, { emit }) {
    const { getCatLink } = useUiHelpers();
    const windowWidth = ref(0);

    const closeDrawer = () => {
      emit("close");
    };

    const isMobile = () => windowWidth.value <= 768;

    const onCustomLinkClick = (link: string) => {
      window.open(link, "_blank");
    };

    const hasChildren = (category: CategoryTree) =>
      Boolean(category?.children?.length);

    onMounted(() => {
      windowWidth.value = window.innerWidth;
      window.addEventListener("resize", handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize);
    });

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    return {
      isMobile,
      closeDrawer,
      hasChildren,
      getCatLink,
      onCustomLinkClick,
    };
  },
});
